const KEY = "analytics_consent";

export type ConsentValue = "accepted" | "rejected" | null;

export function getConsent(): ConsentValue {
  return localStorage.getItem(KEY) as ConsentValue;
}

export function setConsent(value: "accepted" | "rejected") {
  localStorage.setItem(KEY, value);
}

export function hasConsented(): boolean {
  return getConsent() === "accepted";
}
